import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/main-container/page-container/MoveToMainPageImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInBtn","SignOutBtn"] */ "/opt/build/repo/app/components/main-container/page-container/SignBtn.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/app/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/util/provider/ReactQueryProvider.tsx");
